import { render, staticRenderFns } from "./SectorGrid.vue?vue&type=template&id=119edd95&scoped=true&"
import script from "./SectorGrid.vue?vue&type=script&lang=js&"
export * from "./SectorGrid.vue?vue&type=script&lang=js&"
import style0 from "./SectorGrid.vue?vue&type=style&index=0&id=119edd95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119edd95",
  null
  
)

export default component.exports